import GridManager from "./GridManager/GridManager";
import PanelManager from "./PanelManager/PanelManager";
import TestModeModal from "../entities/TestModeModal/TestModeModal";


export default class ComponentManager {
  constructor() {
    new PanelManager();
    new GridManager();
    new TestModeModal();
  }
}